import { takeEvery } from 'redux-saga/effects'

import { ProjectAvatarActions } from '../actions'
import { reset } from './reset'
import { upload } from './upload'

export function* projectAvatarSaga() {
  yield takeEvery(ProjectAvatarActions.upload, upload)
  yield takeEvery(ProjectAvatarActions.reset, reset)
}
